/* eslint-disable */
import { appConfigs } from "../../../config";

const Home = () => {
    window.location.assign(appConfigs.COMPANY_URL)
    return null
}

export default Home;
